<template>
  <div v-if="$store.getters.retrieveAnon">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn
          v-if="bottom"
          style="height: 100%; width: 60px; min-width: 60px !important"
          v-on="on"
        >
          <span>Sign In</span>
          <v-icon>mdi-account-circle-outline</v-icon>
        </v-btn>

        <v-btn v-else outlined block large color="blue darken-2" v-on="on">
          Sign In
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="mb-4">
          <h4>Sign In</h4>
          <v-spacer></v-spacer>
          <v-btn icon color text @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-alert class="text-left" border="left" text type="info">
            If you already have an account just sign in here and we'll move over
            any items you've added to you basket to your account.
          </v-alert>
        </v-card-text>

        <v-form ref="SignInForm" @submit.prevent v-model="valid">
          <v-row v-if="error">
            <v-card-title>
              <v-icon left color="error" class="mr-2 ml-2"
                >error_outline</v-icon
              >
              <span class="error--text ml-2">Sign In Failed</span>
            </v-card-title>
            <v-card-text class="ml-3 error--text">{{
              errorMessage
            }}</v-card-text>
          </v-row>
          <v-card-text class="py-0">
            <v-text-field
              outlined
              label="Email address"
              name="email"
              prepend-inner-icon="mdi-email"
              type="email"
              v-model="email"
              :rules="emailRules"
            />

            <v-text-field
              outlined
              id="password"
              label="Password"
              name="password"
              prepend-inner-icon="lock"
              type="password"
              v-model="password"
              :rules="passwordRules"
            />
          </v-card-text>
          <v-card-actions class="dialogActions">
            <v-spacer />
            <v-btn
              large
              type="submit"
              :loading="signInLoading"
              color="blue darken-2"
              @click="submit"
              outlined
              :disabled="!valid"
            >
              Sign In
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import checkPostCode from "@/util/validation/postcode.js";

export default {
  props: {
    bottom: Boolean,
  },

  data() {
    return {
      dialog: false,
      valid: false,

      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      password: "",
      passwordRules: [(v) => !!v || "Password is required"],

      showSignupMessage: false,
      error: false,
      errorMessage: "",
      signInLoading: false,
    };
  },

  methods: {
    ...mapActions([
      "getCustomer",
      "setSnackbar",
      "authUser",
      "getCustomer",
      "getTrollys",
      "setAnonUser",
    ]),

    async submit() {
      if (this.$refs.SignInForm.validate() && !this.signInLoading) {
        let payload = {
          identity: "nws9987",
          email_addr: this.email,
          password: this.password,
          anonId: this.$store.getters.retrieveUser.userNum,
        };
        this.error = false;
        this.errorMessage = "";

        this.signInLoading = true;

        let authResponse = await this.authUser(payload);

        if (authResponse) {
          if (authResponse.success) {
            this.setAnonUser(false);
            await this.getCustomer(false);
            await this.getTrollys(false);
          } else {
            console.log("-- Auth Error");
            this.error = true;

            if (authResponse.message) {
              this.errorMessage = authResponse.message;
            } else {
              this.errorMessage = "Incorrect Username or Password";
            }
          }
        } else {
          this.setSnackbar({
            color: "error",
            text: "Connection to server timed out",
          });
        }

        this.signInLoading = false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>